export default __webpack_public_path__ + "static/media/tk_seed.7fa03b43.png";